<template>
  <div class="strategy-header">
    <div class="left-content">
      <RemoteImg
        :src="logo"
        box-style="margin: 0.75rem;"
        size="auto; max-height: 115px;"
      />
      <div class="title-group">
        <span class="title-line">
          <span class="likes"> {{ likes }} <i class="fa fa-thumbs-o-up mr-1" aria-hidden="true"></i></span>
          <h5 class="grid-title mb-1">
            {{ name }}
          </h5>
          <span class="price"><i class="fa fa-dollar mr-1" aria-hidden="true"></i>( {{ price * 100 }}% )</span>
          <p class="grid-subtitle mb-0 text-muted">
            {{ subtitleL1 }}
          </p>
          <p v-if="settings.show_balance" class="grid-subtitle mb-0 text-muted">
            {{ subtitleL2 }}
          </p>
        </span>
      </div>
    </div>

    <div v-if="!hideButtons" class="right-content">
      <div class="grid-buttons d-flex flex-column align-items-end">
        <div class="button-wrapper">
          <p-button
            :class="btnClass('secondary')"
            :style="btnStyle(2)"
            class="full-width-btn"
            @click="register"
          >
            {{ $t('registertofollowtxt') }}
          </p-button>
          <p-button
            :class="btnClass('primary')"
            :style="btnStyle(1)"
            class="full-width-btn"
            @click="goLogin"
          >
            {{ $t('logintofollow') }}
          </p-button>
        </div>
        <LanguageSelect />
      </div>
    </div>
  </div>
</template>


<script>
import LanguageSelect from 'src/components/Dashboard/Views/Components/LanguageSelect.vue';

export default {
  name: 'StrategyHeader',
  components: { LanguageSelect },
  props: {
    logo:        { type: String },
    name:        { type: String },
    likes:       { type: Number },
    price:       { type: Number },
    subtitleL1:    { type: String, default: '' },
    subtitleL2:    { type: String, default: '' },
    isWlSession: { type: Boolean, default: false },
    hideButtons: { type: Boolean, default: false },
    settings:    { type: Object,  default: () => ({}) },
    strategyId: { type: Number },
    affId: {type: String}
  },
  computed: {
    btnClass() {
      return type => this.isWlSession ? '' : `btn-rebrand-${type}`;
    },
    btnStyle() {
      return n => this.isWlSession
        ? { backgroundColor: this.settings[`bgcolor_btn${n}`] }
        : {};
    }
  },
  methods: {
    goLogin() {
      window.open(`/login?strat_id=${this.strategyId}`)
    },
    register() {
      // IF is whitelabel
      if(!Object.keys(this.settings).length === 0) {
        this.settings && localStorage.setItem('wlSettings', JSON.stringify(this.settings));
      }
      window.open(`/register/${this.affId}/${this.strategyId}`);
    },
  }
};
</script>

<style lang="scss" scoped>
@import 'src/assets/sass/paper/variables';
.strategy-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 1.5rem;
  gap: 1rem;
}
.left-content {
  display: flex;
  flex: 1 1 60%;
  flex-wrap: wrap;
  align-items: center;
  min-width: 200px;
}
.title-group {
  display: flex;
  flex: 1 1 auto;
  margin-left: 1rem;
  min-width: 0;
}
.title-line {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 0.5rem;
  min-width: 0;
}
.grid-title {
  font-size: 2rem;
  font-weight: bold;
  margin: 0;
  white-space: nowrap;
  flex-shrink: 0;
}
.grid-subtitle {
  font-size: 1rem;
  color: #6c757d;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-shrink: 1;
  min-width: 0;
}
.right-content {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  min-width: 180px;
}
.grid-buttons {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.button-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: stretch;
  .btn {
    margin-bottom: 0 !important;
  }
}
.full-width-btn {
  width: 100%;
}
.price {
  color: $brand-success !important;
  font-size: x-large;
  font-weight: bolder;
}
.likes {
  color: $fb-blue-color !important;
  font-size: large;
  font-weight: bolder;
}
@media (max-width: 768px) {
  .strategy-header {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .left-content {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .title-group {
    margin-left: 0;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
  }
  .right-content {
    align-items: center;
  }
  .grid-buttons {
    align-items: center;
  }
  .grid-subtitle,
  .grid-title {
    white-space: normal;
  }
}
</style>
